import { Controller } from '@hotwired/stimulus'
import { updateUrlParams } from '../../../helpers/url_helper'

export default class extends Controller {
  static outlets = ['wip--side-bar', 'tablist']
  static targets = ['hideElement', 'unreadBadge']

  connect() {
    this.currentTab = null

    document.addEventListener('tablist:tabChanged', this.handleSidebarTabChange)
    document.addEventListener('reporting-cycle:comment-added', this.handleCommentAdded)
    window.addEventListener('galette:sidebar:close', this.sidebarClosed)
  }

  disconnect() {
    document.removeEventListener('tablist:tabChanged', this.handleSidebarTabChange)
    document.removeEventListener('reporting-cycle:comment-added', this.handleCommentAdded)
    window.removeEventListener('galette:sidebar:close', this.sidebarClosed)
  }

  handleSidebarTabChange = event => {
    // If the tablist is not the one in the sidebar, return
    if (!this.hasWipSideBarOutlet || !this.wipSideBarOutlet.element.querySelector(`#${event.detail?.id}`)) {
      return
    }

    const tabPanelId = event.detail?.tabPanelId
    if (tabPanelId?.startsWith('panel-')) {
      const tabName = tabPanelId.replace('panel-', '')
      this.currentTab = tabName

      // Only update URL if sidebar is open
      if (this.wipSideBarOutlet.isOpen()) {
        updateUrlParams({ tab: tabName })
      }
    }
  }

  handleCommentAdded = () => {
    this._markCommentAsUnread()
  }

  _markCommentAsUnread() {
    const unreadElements = document.querySelectorAll('[data-comments--read-tracker-is-unread-value]')
    const unreadFalseCount = Array.from(unreadElements).filter(
      el => el.getAttribute('data-marked-as-read') === null || el.getAttribute('data-marked-as-read') === 'false'
    ).length
    if (unreadFalseCount === 0) {
      this.unreadBadgeTarget.classList.add('d-none')
    } else {
      this.unreadBadgeTarget.classList.remove('d-none')
    }
  }

  sidebarClosed = () => {
    this._setTab(null)
    this._hideButtons(false)
    this._markCommentAsUnread()
  }

  openSidebarWithTab(event) {
    event.preventDefault()

    if (!this.hasWipSideBarOutlet) {
      console.warn('No sidebar outlet available')
      return
    }

    if (!this.wipSideBarOutlet.isOpen()) {
      this.wipSideBarOutlet.open()
    }

    const tabName = event.params.tab
    if (this.currentTab !== tabName) {
      this.tablistOutlet.selectTab(tabName)
      this._setTab(tabName)
    }

    this._hideButtons(true)
  }

  _hideButtons(hide) {
    if (hide) {
      this.hideElementTargets.forEach(element => {
        element.classList.add('d-none')
      })
    } else {
      this.hideElementTargets.forEach(element => {
        element.classList.remove('d-none')
      })
    }
  }

  _setTab(tabName) {
    this.currentTab = tabName
    updateUrlParams({ tab: tabName })
  }
}
